import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["nameInput", "extCheckbox", "pipelineCheckbox"]
  static values = {
    baseUrl: String
  }

  connect() {
    this.debounceTimer = null
  }

  disconnect() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
    }
  }

  debounceFilter() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
    }

    this.debounceTimer = setTimeout(() => {
      this.applyFilter()
    }, 300)
  }

  applyFilter() {
    const url = new URL(this.baseUrlValue, window.location.origin)

    // Preserve sort param from current URL
    const currentUrl = new URL(window.location.href)
    const sortParam = currentUrl.searchParams.get("sort")
    if (sortParam) {
      url.searchParams.set("sort", sortParam)
    }

    // Add name filter
    const nameValue = this.hasNameInputTarget ? this.nameInputTarget.value.trim() : ""
    if (nameValue) {
      url.searchParams.set("name", nameValue)
    }

    // Add extension checkboxes (multiple)
    this.extCheckboxTargets.filter(cb => cb.checked).forEach(cb => {
      url.searchParams.append("ext[]", cb.value)
    })

    // Add pipeline checkboxes (multiple)
    this.pipelineCheckboxTargets.filter(cb => cb.checked).forEach(cb => {
      url.searchParams.append("pipeline[]", cb.value)
    })

    Turbo.visit(url.toString(), { action: "replace" })
  }

  clearFilters() {
    const url = new URL(this.baseUrlValue, window.location.origin)

    // Preserve sort param from current URL
    const currentUrl = new URL(window.location.href)
    const sortParam = currentUrl.searchParams.get("sort")
    if (sortParam) {
      url.searchParams.set("sort", sortParam)
    }

    Turbo.visit(url.toString(), { action: "replace" })
  }
}
